import { IStyle } from '@fluentui/react';

import { defaultPalette } from '../../themes/colors';
import { ZIndices } from '../../themes/styles';

export interface IEditorStyles {
  root?: IStyle;
}

export interface IEditorClassNames {
  root: string;
}

export const editorStylesDefault: IEditorStyles = {
  root: {
    position: 'absolute',
    display: 'inline-block',
    zIndex: ZIndices.first,
    backgroundColor: defaultPalette.white,
  },
};
